import React from 'react';
import { colors } from '@styleseat/brand';

type BasicDropIconProps = {
  width?: number;
  height?: number;
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const BasicDropIcon = ({
  width = 24,
  height = 24,
  color = colors.blackInBlack,
}: BasicDropIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.6577 1.24674C18.1887 6.07627 21 10.2932 21 14C21 19.2493 16.9029 23 12 23C7.09705 23 3 19.2493 3 14C3 10.2932 5.81131 6.07627 11.3423 1.24674L12 0.672424L12.6577 1.24674ZM5 14C5 18.1034 8.16411 21 12 21C15.8359 21 19 18.1034 19 14C19 11.1508 16.6934 7.56645 12 3.33659C7.30661 7.56645 5 11.1508 5 14ZM12 18V20C15.3137 20 18 17.3137 18 14H16C16 16.2091 14.2091 18 12 18Z"
      fill={color}
    />
  </svg>
);
